// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
//
// import { Subscription } from 'rxjs';
//
// import { AuthService } from '../../account/shared/auth.service';
// import { OffcanvasService } from '../shared/offcanvas.service';
//
// import { User } from '../../models/user.model';
//
// @Component({
//   selector: 'app-header',
//   templateUrl: './header.component.html',
//   styleUrls: ['./header.component.scss']
// })
// export class HeaderComponent implements OnInit, OnDestroy {
//   private authSubscription: Subscription;
//   public user: User;
//   public showSearch;
//
//   constructor(
//     private authService: AuthService,
//     private router: Router,
//     private offcanvasService: OffcanvasService
//   ) {}
//
//   ngOnInit() {
//     this.authSubscription = this.authService.user.subscribe((user) => {
//       this.user = user;
//     });
//   }
//
//   public onLogOut(e: Event) {
//     this.authService.signOut();
//     this.router.navigate(['/register-login']);
//     e.preventDefault();
//   }
//
//   public onMenuToggle(e: Event) {
//     this.offcanvasService.openOffcanvasNavigation();
//     e.preventDefault();
//   }
//
//   ngOnDestroy() {
//     this.authSubscription.unsubscribe();
//   }
// }

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../account/shared/auth.service';
import { OffcanvasService } from '../shared/offcanvas.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private authSubscription: Subscription;
  public user: User;
  public showSearch: boolean = false;
  public isMobileMenuOpen: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    public offcanvasService: OffcanvasService
  ) {}

  ngOnInit() {
    this.authSubscription = this.authService.user.subscribe((user) => {
      this.user = user;
    });
  }

  public onLogOut(e: Event) {
    this.authService.signOut();
    this.router.navigate(['/register-login']);
    e.preventDefault();
  }

  public onMenuToggle(e: Event) {
    this.offcanvasService.toggleOffcanvasNavigation();
    e.preventDefault();
  }

  public onSearchInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 0) {
      this.showSearch = true;
    } else {
      this.showSearch = false;
    }
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }
}
